import { axiosInstance, loginInstance } from "./Axios";

export const getOTP = (data) => {
  return axiosInstance.post("/user/otp", data);
};

export const loginAPI = (loginData) => {
  return loginInstance.post("/auth", loginData);
};
